import _ from 'lodash'
import React from 'react'
import { connect, useDispatch } from 'react-redux'
import { change } from 'redux-form'
import { useActiveTestType } from '../authorised/impressionFinding/helpers/useActiveTestType'
import { findingSettingCreate } from '../../redux/actions/settingActions/findingSettingActions'
import { examFindingInfo } from '../../redux/actions/exam/examFindingActions'

function CopyToDestination(props) {
  const dispatch = useDispatch()
  const { examExternalInternalForm, examAdditionalTestForm, source, showCopy: { destination, title, formName }, showFindingField } = props
  const activeTestType = useActiveTestType(source)

  const copyTo = (formName) => {
    formName = formName ? formName : 'examExternalInternalForm'
    const fromData = formName == 'examAdditionalTestForm' ? examAdditionalTestForm : examExternalInternalForm
    const sourceNode = _.get(fromData, source)
    dispatch(change(`${formName}`, `${destination}`, sourceNode))
    if (showFindingField && sourceNode) {
      handleCreateFinding(sourceNode)
    }
  }

  const handleCreateFinding = async (value) => {
    let test_type = activeTestType.replace(/_(os|od)/g, (_, val) => `_${val === 'os' ? 'od' : 'os'}`);
    await dispatch(findingSettingCreate({ name: value, test_type: test_type }))
    dispatch(examFindingInfo({ activeFieldType: activeTestType, dropdownType: 'finding' }))
    document.getElementsByName(destination)?.[0]?.focus()
  }

  return (
    <small className="float-right btn-link" onClick={() => copyTo(formName)}><i className="la la-copy" />{title}</small>
  )
}

const mapStateToProps = state => {
  const { form: { examExternalInternalForm, examAdditionalTestForm }, setting: { orgConfig } } = state
  return {
    examExternalInternalForm: examExternalInternalForm?.values,
    examAdditionalTestForm: examAdditionalTestForm?.values,
    showFindingField: orgConfig.org_config?.exam_settings?.auto_diagnosis
  };
};

export default connect(mapStateToProps)(CopyToDestination);